import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface ActCurrentParams {
  cdTerritory: string;
  tokenKey: string;
}

export const getActCurrentByCdTerritory = async (params: ActCurrentParams) => {
  const query = qs.stringify(params);
  return apiConfig
    .get(`api/ActDocument/get-act-current-by-cdTerritory?${query}`)
    .then((resp) => resp.data)
    .catch((err) => err);
};
